import pages from '../pages';
import * as paths from './paths';

export const PAGE_IMAGE_LABELS = {
  component: pages.ImageLabelsPage,
  path: paths.IMAGE_LABELS_PATH,
  isPrivate: false,
};

export const PAGE_LEMONADE = {
  component: pages.LemonadePage,
  path: paths.LEMONADE_PATH,
  isPrivate: false,
};

export const PAGE_LEMONADE_EDITOR_TYPE = {
  component: pages.LemonadeEditorPage,
  // provider: providers.LemonadeConfigProvider,
  path: paths.LEMONADE_EDITOR_TYPE_PATH,
  isPrivate: false,
  props: { data: null },
};
export const PAGE_LEMONADE_EDITOR = {
  component: pages.LemonadeEditorPage,
  // provider: providers.LemonadeConfigProvider,
  path: paths.LEMONADE_EDITOR__PATH,
  isPrivate: false,
  props: { type: 'multiple-choice', data: null },
};
export const PAGE_GENERATOR = {
  component: pages.GeneratorPage,
  // provider: providers.LemonadeConfigProvider,
  path: paths.GENERATOR_PATH,
  isPrivate: false,
  props: { customType: 'order-list-generator' },
};
export const PAGE_SCAFFOLD_EXAMPLE = {
  component: pages.ScaffoldExamplePage,
  path: paths.SCAFFOLD_EXAMPLE_PATH,
  isPrivate: false,
};
export const PAGE_SCAFFOLD_MOBILE = {
  component: pages.ScaffoldMobilePage,
  path: paths.SCAFFOLD_MOBILE_VIEWER_PATH,
  isPrivate: false,
};
export const PAGE_SCAFFOLD_MOBILE_CUSTOM = {
  component: pages.ScaffoldMobileCustomPage,
  path: paths.SCAFFOLD_MOBILE_CUSTOM_PATH,
  isPrivate: false,
};
export const PAGE_SCAFFOLD_VIEWER = {
  component: pages.ScaffoldingViewerPage,
  path: paths.SCAFFOLD_VIEWER_PATH,
  isPrivate: false,
};
export const PAGE_QUESTION_VIEWER = {
  component: pages.QuestionViewerPage,
  // provider: providers.LemonadeConfigProvider,
  path: paths.QUESTION_VIEWER_PATH,
  isPrivate: false,
  props: { customType: 'order-list-generator' },
};

export const PAGE_LEMONADE_ACTIVITY_PREVIEW = {
  component: pages.LemonadeActivityPreviewPage,
  path: paths.LEMONADE_ACTIVITY_PREVIEW_PATH,
  isPrivate: false,
};
export const PAGE_STYLE_GUIDE = {
  component: pages.StyleGuidePage,
  path: paths.STYLE_GUIDE_PATH,
  isPrivate: false,
};

export const PAGE_PLAYGROUND_MATH = {
  component: pages.PlaygroundMathPage,
  path: paths.PLAYGROUND_MATH_PATH,
  isPrivate: false,
};

export const PAGE_ALL_QUESTIONS = {
  component: pages.AllQuestionsPage,
  path: paths.ALL_QUESTIONS_PATH,
  isPrivate: false,
};

export const PAGE_ALL_EDITORS = {
  component: pages.AllEditorsPage,
  path: paths.ALL_EDITORS_PATH,
  isPrivate: false,
};

export const PAGE_CLOCK = {
  component: pages.ClockPage,
  path: paths.CLOCK_PATH,
  isPrivate: false,
};

export const PAGE_VIDEOLESSON = {
  component: pages.VideolessonPage,
  path: paths.VIDEOLESSON_PATH,
  isPrivate: false,
};

export const PAGE_MINT = {
  component: pages.MintPage,
  path: paths.MINT_PATH,
  isPrivate: false,
};

export const PAGE_COURSE_MINT = {
  component: pages.MintCoursePage,
  path: paths.MINT_COURSE_PATH,
  isPrivate: false,
};

export const PAGE_AI = {
  component: pages.AiPage,
  path: paths.AI_PATH,
  isPrivate: false,
};

export const PAGE_VIDEO_RECORDER = {
  component: pages.VideoRecorderPage,
  path: paths.VIDEO_RECORDER_PATH,
  isPrivate: false,
};

export const PAGE_KC_PLAYGROUND = {
  component: pages.KCPlaygroundPage,
  path: paths.KC_PLAYGROUND_PATH,
  isPrivate: false,
};

export const PAGE_ACTIVITIES_PLAYGROUND = {
  component: pages.ActivitiesPlaygroundPage,
  path: paths.ACTIVITIES_PLAYGROUND_PATH,
  isPrivate: false,
};

export const PAGE_KC_ORCHESTRATOR = {
  component: pages.KcOrchestratorPage,
  path: paths.KC_ORCHESTRATOR_PATH,
  isPrivate: false,
};

export const PAGE_HOME = {
  component: pages.HomePage,
  path: paths.HOME_PATH,
  isPrivate: false,
};

export default [
  PAGE_IMAGE_LABELS,
  PAGE_LEMONADE,
  PAGE_LEMONADE_EDITOR_TYPE,
  PAGE_LEMONADE_EDITOR,
  PAGE_GENERATOR,
  PAGE_SCAFFOLD_EXAMPLE,
  PAGE_SCAFFOLD_MOBILE,
  PAGE_SCAFFOLD_MOBILE_CUSTOM,
  PAGE_SCAFFOLD_VIEWER,
  PAGE_QUESTION_VIEWER,
  PAGE_LEMONADE_ACTIVITY_PREVIEW,
  PAGE_STYLE_GUIDE,
  PAGE_PLAYGROUND_MATH,
  PAGE_ALL_QUESTIONS,
  PAGE_ALL_EDITORS,
  PAGE_CLOCK,
  PAGE_VIDEOLESSON,
  PAGE_MINT,
  PAGE_COURSE_MINT,
  PAGE_KC_PLAYGROUND,
  PAGE_ACTIVITIES_PLAYGROUND,
  PAGE_KC_ORCHESTRATOR,
  PAGE_AI,
  PAGE_VIDEO_RECORDER,
  PAGE_HOME,
];
